import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import ZOAddressSearch$1 from '@zillow/zo-address-search';
import PropTypes from 'prop-types';
import React from 'react';

var BlockZOAddressSearch = function BlockZOAddressSearch(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  return /*#__PURE__*/React.createElement(ZOAddressSearch$1, _extends({}, attrs, {
    key: index
  }));
};
BlockZOAddressSearch.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    origin: PropTypes.string,
    internalTrackingCode: PropTypes.string,
    entrySource: PropTypes.string,
    useNewLeadForm: PropTypes.bool,
    surfaceID: PropTypes.string,
    shouldAutoSubmit: PropTypes.bool
  }),
  index: PropTypes.number
} : {};
var ZOAddressSearch = BlockZOAddressSearch;

export { ZOAddressSearch as default };
